module.exports = "<div class=\"well\">Whoops! It looks like an error occurred. Please retry.</div>";


//////////////////
// WEBPACK FOOTER
// ./src/shared/loading-error.html
// module id = 2
// module chunks = 0